module.exports = __webpack_public_path__ + "img/9788949123134.d75712bf.jpg";